var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5.125C2.5 4.64175 2.89175 4.25 3.375 4.25H16.625C17.1082 4.25 17.5 4.64175 17.5 5.125C17.5 5.60825 17.1082 6 16.625 6V17.25C16.625 17.8713 16.1213 18.375 15.5 18.375H4.5C3.87868 18.375 3.375 17.8713 3.375 17.25V6C2.89175 6 2.5 5.60825 2.5 5.125ZM5.125 6V16.625H14.875V6H5.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 3.375V4.25H6.625V2.75C6.625 2.12868 7.12868 1.625 7.75 1.625H12.25C12.8713 1.625 13.375 2.12868 13.375 2.75V4.25H11.625V3.375H8.375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 7.5C8.73325 7.5 9.125 7.89175 9.125 8.375V14.375C9.125 14.8582 8.73325 15.25 8.25 15.25C7.76675 15.25 7.375 14.8582 7.375 14.375V8.375C7.375 7.89175 7.76675 7.5 8.25 7.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 7.5C12.2332 7.5 12.625 7.89175 12.625 8.375V14.375C12.625 14.8582 12.2332 15.25 11.75 15.25C11.2668 15.25 10.875 14.8582 10.875 14.375V8.375C10.875 7.89175 11.2668 7.5 11.75 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.77cc76651118fe6a1272f3beeb6bc973.svg";
export { ForwardRef as ReactComponent };